// extracted by mini-css-extract-plugin
export default {"header":"HeadlineWithReviewChangesLink_header__o5yjZ","reviewTitle":"HeadlineWithReviewChangesLink_reviewTitle__-xT7y","title":"HeadlineWithReviewChangesLink_title__t1A+c"};